import './sort-th.styles.scss';

// A column header that sorts its table (see utils/useSortable). first:
// the direction of the first click ('desc' for most stats, 'asc' for
// names and stats where lower is better).
const SortTh = ({ k, label, sorter, first = 'desc', className = '', title }) => {
    const active = sorter.sort?.key === k;
    const dir = active ? sorter.sort.dir : null;
    return (
        <th className={`${className} sort-th ${active ? 'sorted' : ''}`} title={title}
            aria-sort={dir === 'asc' ? 'ascending' : dir === 'desc' ? 'descending' : 'none'}>
            <button type='button' className='sort-btn' onClick={() => sorter.toggle(k, first)}>
                {label}<span className='sort-arrow' aria-hidden='true'>{dir === 'asc' ? '▲' : dir === 'desc' ? '▼' : ''}</span>
            </button>
        </th>
    );
};

export default SortTh
